<template>
  <el-submenu index="Comn_manage" v-if="canShowSubMenuItem">
    <template slot="title">{{ $t("Comn_manage") }}</template>
    <router-link
      v-for="(item, key) in filterMenuItemsByPermissions"
      :key="key"
      :to="item.route"
      class="menu-item-wrapper"
    >
      <li
        class="el-menu-item"
        :class="{ 'is-active': $route.meta.langKey === item.langKey }"
        :index="item.langKey"
        :route="item.route"
      >
        <img class="menu-image" :src="renderMenuIcon(item.imgKey)" />
        <p class="menu-title truncate" v-if="getSideNavStatus">
          {{ $t(item.langKey) }}
        </p>
      </li>
    </router-link>
  </el-submenu>
</template>

<script>
import { mapGetters } from "vuex";
import renderMenuIcon from "./renderMenuIcon";
import {
  permissionsToStringMap as permissions,
  userTypes
} from "@/middleware/pageAccessManager";

export default {
  computed: {
    ...mapGetters("header", {
      getSideNavStatus: "getSideNavStatus"
    }),
    menuItems: function() {
      return {
        // STOCKS: {
        //   langKey: "Stock_stock",
        //   route: "/user/stock?tab=feed",
        //   imgKey: "STOCKS",
        //   keyToValidateAccess: "PERMISSIONS",
        //   PERMISSIONS: [permissions.MANAGE_STOCK]
        // },
        GATEWAY: {
          langKey: "Comn_gateway",
          route: "/user/gateway?tab=deviceInfoTab",
          imgKey: "GATEWAY",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [
            permissions.MANAGE_CULTURE,
            permissions.MANAGE_SCHEDULES,
            permissions.MANAGE_DEVICES
          ]
        },
        REPORTS: {
          langKey: "Comn_reports",
          route: "/user/reports",
          imgKey: "REPORTS",
          keyToValidateAccess: "USER_TYPES",
          USER_TYPES: [
            userTypes.admin,
            userTypes.pond_manager,
            userTypes.pond_owner
          ]
        },
        RESOURCES: {
          langKey: "Comn_resources",
          route: "/user/resources",
          imgKey: "RESOURCES",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [
            permissions.MANAGE_MEDICINE,
            permissions.MANAGE_LAB_TESTS,
            permissions.MANAGE_STOCK
          ]
        }
      };
    },
    filterMenuItemsByPermissions: function() {
      return this.itemsUserCanView(this.menuItems);
    },
    canShowSubMenuItem: function() {
      return Object.keys(this.filterMenuItemsByPermissions).length > 0;
    }
  },
  methods: {
    renderMenuIcon
  }
};
</script>

<style></style>
